<div class="loading-shade" *ngIf="isLoading">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>
<div class="main-ho-notifications">
  <!-- Notification #1 appears before the well type selector only in HO3 and for engineers -->
  <div class="notification-panel" *ngIf="notificationWellControlEvent">
    <div class="notification">
      <div class="control">
        <div>
          <mat-slide-toggle
            [checked]="notificationWellControlEvent.value.activeSelected"
            (change)="
              onToggleNotification(
                notificationWellControlEvent,
                this.originalNotificationValueWellControlEvent
              )
            "
            [(ngModel)]="notificationWellControlEvent.value.activeSelected"
            [disabled]="
              readOnlyContent ||
              !isUserResponsibleOfNotification(notificationWellControlEvent)
            "
          >
            {{
              notificationWellControlEvent.value.activeSelected
                ? notificationWellControlEvent.notificationLabelActive
                : notificationWellControlEvent.notificationLabelInactive
            }}
          </mat-slide-toggle>
        </div>
        <div>
          <mat-form-field
            *ngIf="notificationWellControlEvent.value.activeSelected"
          >
            <mat-label>{{
              notificationWellControlEvent.inputPlaceholder
            }}</mat-label>
            <div matTooltip="{{ notificationWellControlEvent.value.value }}">
              <input
                matInput
                type="text"
                (ngModelChange)="
                  onTextNotificationValueChanges(
                    notificationWellControlEvent,
                    $event,
                    this.originalNotificationValueWellControlEvent.value || ''
                  )
                "
                [(ngModel)]="notificationWellControlEvent.value.value"
                [disabled]="readOnlyContent"
              />
            </div>
            <mat-hint
              class="alert"
              *ngIf="
                notificationWellControlEvent.required &&
                !readOnlyContent &&
                !notificationWellControlEvent.value.value
              "
              >Este campo es obligatorio.</mat-hint
            >
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="well-production-wrapper">
    <div class="well-type" *ngIf="displayWellTypeSelector">
      <mat-form-field class="selector" appearance="fill">
        <mat-label>Tipo de Pozo</mat-label>
        <mat-select
          [(ngModel)]="chosenWellType"
          (selectionChange)="onChangeWellType($event.value)"
          [disabled]="readOnlyContent || !canUserChooseWellType()"
          [compareWith]="compareObjectsWellType"
        >
          <mat-option [value]="{}" *ngIf="!chosenWellType.wellTypeId"
            >Seleccionar</mat-option
          >
          <mat-option *ngFor="let wellType of wellTypes" [value]="wellType">
            {{ wellType.name }}
          </mat-option>
        </mat-select>
        <mat-hint
          class="alert"
          *ngIf="
            !readOnlyContent &&
            (chosenWellType | json) == '{}' &&
            canUserChooseWellType()
          "
        >
          Este campo es obligatorio.
        </mat-hint>
      </mat-form-field>
      <mat-form-field *ngIf="displayOtherWellTypeInput">
        <mat-label>Nombre o identificador</mat-label>
        <input
          matInput
          type="text"
          (ngModelChange)="onChangeOtherWellTypeInput($event)"
          [(ngModel)]="otherWellTypeInput"
          [disabled]="readOnlyContent"
        />
        <mat-hint
          class="alert"
          *ngIf="
            !readOnlyContent && !otherWellTypeInput && canUserChooseWellType()
          "
          >Este campo es obligatorio.</mat-hint
        >
      </mat-form-field>
    </div>

    <div class="well-type">
      <mat-form-field class="selector" appearance="fill">
        <mat-label>Tipo de Produccion</mat-label>
        <mat-select
          [(ngModel)]="chosenProductionType"
          (selectionChange)="onChangeProductionType($event.value)"
          [disabled]="readOnlyContent || !canUserChooseWellType()"
          [compareWith]="compareObjectsProductionType"
        >
          <mat-option
            [value]="{}"
            *ngIf="!chosenProductionType.productionTypeId"
            >Seleccionar</mat-option
          >
          <mat-option
            *ngFor="let productionType of productionTypes"
            [value]="productionType"
          >
            {{ productionType.productionType }}
          </mat-option>
        </mat-select>
        <mat-hint
          class="alert"
          *ngIf="
            !readOnlyContent &&
            (chosenProductionType | json) == '{}' &&
            canUserChooseWellType()
          "
        >
          Este campo es obligatorio.
        </mat-hint>
      </mat-form-field>
    </div>
    <div>
      <p class="text">
        El listado de “Elemetos de barrera” sera modificado <br>segun el “Tipo de Producción” selecionado.
      </p>
    </div>
  </div>
  <p class="title-section">Notificaciones</p>

  <!-- Empty state -->
  <div class="empty-content" *ngIf="!displayNotifications">
    <p class="title">No hay notificaciones aún</p>
    <p class="text">
      Al seleccionar la tipología de pozo podrás visualizar acá<br />las
      Notificaciones específicas de la tipología indicada
    </p>
  </div>

  <!-- First notification stands alone, except for HOEC and HOAC
       TODO: REFACTORIZAR EL HARCODE DE ESTAS NOTIFICACIONES
  -->
  <div
    class="notification-panel"
    *ngIf="
      displayNotifications &&
      handover?.handoverTypeId != handoverTypeHOEC &&
      handover?.handoverTypeId != handoverTypeHOAC
    "
  >
    <div
      class="notification"
      *ngIf="notificationPassesRDFilter(notifications[0])"
    >
      <!-- It may be a comment notification... -->
      <div
        class="control"
        *ngIf="notificationTypeComment == notifications[0].notificationType"
      >
        <div>
          <mat-slide-toggle
            [checked]="notifications[0].value.activeSelected"
            (change)="
              onToggleNotification(
                notifications[0],
                this.originalNotificationValues[notifications[0].originalIndex]
              )
            "
            [(ngModel)]="notifications[0].value.activeSelected"
            [disabled]="
              readOnlyContent ||
              !isUserResponsibleOfNotification(notifications[0])
            "
          >
            {{
              notifications[0].value.activeSelected
                ? notifications[0].notificationLabelActive
                : notifications[0].notificationLabelInactive
            }}
          </mat-slide-toggle>
        </div>
        <div>
          <mat-form-field *ngIf="notifications[0].value.activeSelected">
            <mat-label>{{ notifications[0].inputPlaceholder }}</mat-label>
            <div matTooltip="{{ notifications[0].value.value }}">
              <input
                matInput
                type="text"
                (ngModelChange)="
                  onTextNotificationValueChanges(
                    notifications[0],
                    $event,
                    this.originalNotificationValues[
                      notifications[0].originalIndex
                    ].value || ''
                  )
                "
                [(ngModel)]="notifications[0].value.value"
                [disabled]="
                  readOnlyContent ||
                  !isUserResponsibleOfNotification(notifications[0])
                "
              />
            </div>
            <mat-hint
              class="alert"
              *ngIf="
                notifications[0].required &&
                !readOnlyContent &&
                !notifications[0].value.value
              "
              >Este campo es obligatorio.</mat-hint
            >
          </mat-form-field>
        </div>
      </div>

      <!-- ...or a file attachment. -->
      <div
        class="control attachment"
        *ngIf="notificationTypeFile == notifications[0].notificationType"
      >
        <mat-form-field>
          <mat-label>{{ notifications[0].inputPlaceholder }}</mat-label>
          <div matTooltip="{{ notifications[0].value.value }}">
            <input
              matInput
              type="text"
              (ngModelChange)="
                onTextNotificationValueChanges(
                  notifications[0],
                  $event,
                  this.originalNotificationValues[
                    notifications[0].originalIndex
                  ].value || ''
                )
              "
              [(ngModel)]="notifications[0].value.value"
              [disabled]="readOnlyContent"
            />
          </div>
          <mat-hint
            class="alert"
            *ngIf="
              notifications[0].required &&
              !readOnlyContent &&
              !notifications[0].value.value
            "
            >Este campo es obligatorio.</mat-hint
          >
        </mat-form-field>

        <ng-container
          *ngIf="
            !notifications[0].value.attachment?.filePath &&
            !notifications[0].fileToUpload?.name
          "
        >
          <input
            type="file"
            class="file-input"
            (change)="onFileSelected($event, notifications[0])"
            #fileUpload
          />
          <button
            mat-button
            class="attachment-button"
            title="{{ notifications[0].notificationLabelActive }}"
            (click)="fileUpload.click()"
            [disabled]="readOnlyContent"
          >
            <mat-icon class="material-icons-outlined">file_upload</mat-icon
            >{{ notifications[0].notificationLabelActive }}
          </button>
        </ng-container>

        <div
          *ngIf="
            notifications[0].value.attachment?.filePath ||
            notifications[0].fileToUpload?.name
          "
        >
          <ng-container *ngIf="!notifications[0].value.attachment?.filePath">
            <a
              href="{{dhoApiUrl}}/{{ notifications[0].value.attachment?.filePath }}"
              download="{{ getNameFile(notifications[0].value.attachment) }}"
              class="attachment-link"
              target="_blank"
            >
              {{ getNameFile(notifications[0].value.attachment) }}
            </a>
          </ng-container>
          <ng-container *ngIf="notifications[0].fileToUpload?.name">
            <a
              href="{{ notifications[0].fileToUpload?.name }}"
              class="attachment-link"
              (click)="deniedDownload($event)"
            >
              {{ notifications[0].fileToUpload?.name }}
            </a>
          </ng-container>
          <button
            mat-button
            class="delete-button"
            (click)="onFileDeleted(notifications[0])"
            *ngIf="
              !readOnlyContent &&
              (notifications[0].value.attachment?.filePath ||
                notifications[0].fileToUpload?.name)
            "
          >
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </div>
      </div>

      <button
        mat-button
        *ngIf="
          notifications[0].alwaysAlert || notifications[0].value.activeSelected
        "
        [ngClass]="{
          alert: true,
          active: notifications[0].alwaysAlert || notifications[0].value.alert
        }"
        [disabled]="
          readOnlyContent || !isUserResponsibleOfNotification(notifications[0])
        "
        (click)="onNotificationAlertChanges(notifications[0])"
        matTooltip="{{
          !notifications[0].value.alert
            ? 'Activá si crees que este ítem requiere atención especial'
            : 'Desactivá si crees que este ítem NO requiere atención especial'
        }}"
      >
        <span class="material-icons-outlined"> report_problem </span>
      </button>
    </div>

    <!-- Notification 53 
         TODO: REFACTORIZAR EL HARCODE DE ESTAS NOTIFICACIONES
    -->
    <div
      class="notification"
      *ngIf="
        notification53 > -1 &&
        notificationPassesRDFilter(notifications[notification53])
      "
    >
      <div
        class="control"
        *ngIf="
          notificationTypeComment ==
          notifications[notification53].notificationType
        "
      >
        <div>
          <mat-slide-toggle
            [checked]="notifications[notification53].value.activeSelected"
            (change)="
              onToggleNotification(
                notifications[notification53],
                this.originalNotificationValues[
                  notifications[notification53].originalIndex
                ]
              )
            "
            [(ngModel)]="notifications[notification53].value.activeSelected"
            [disabled]="
              readOnlyContent ||
              !isUserResponsibleOfNotification(notifications[notification53])
            "
          >
            {{
              notifications[notification53].value.activeSelected
                ? notifications[notification53].notificationLabelActive
                : notifications[notification53].notificationLabelInactive
            }}
          </mat-slide-toggle>
        </div>
        <div>
          <mat-form-field
            *ngIf="notifications[notification53].value.activeSelected"
          >
            <mat-label>{{
              notifications[notification53].inputPlaceholder
            }}</mat-label>
            <div matTooltip="{{ notifications[notification53].value.value }}">
              <input
                matInput
                type="text"
                (ngModelChange)="
                  onTextNotificationValueChanges(
                    notifications[notification53],
                    $event,
                    this.originalNotificationValues[
                      notifications[notification53].originalIndex
                    ].value || ''
                  )
                "
                [(ngModel)]="notifications[notification53].value.value"
                [disabled]="
                  readOnlyContent ||
                  !isUserResponsibleOfNotification(
                    notifications[notification53]
                  )
                "
              />
            </div>
            <mat-hint
              class="alert"
              *ngIf="
                notifications[notification53].required &&
                !readOnlyContent &&
                !notifications[notification53].value.value &&
                isUserResponsibleOfNotification(notifications[notification53])
              "
            >
              Este campo es obligatorio.
            </mat-hint>
          </mat-form-field>
        </div>
      </div>

      <button
        mat-button
        *ngIf="
          notifications[notification53].alwaysAlert ||
          notifications[notification53].value.activeSelected
        "
        [ngClass]="{
          alert: true,
          active:
            notifications[notification53].alwaysAlert ||
            notifications[notification53].value.alert
        }"
        [disabled]="readOnlyContent"
        (click)="onNotificationAlertChanges(notifications[notification53])"
        matTooltip="{{
          !notifications[notification53].value.alert
            ? 'Activá si crees que este ítem requiere atención especial'
            : 'Desactivá si crees que este ítem NO requiere atención especial'
        }}"
      >
        <span class="material-icons-outlined"> report_problem </span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="displayNotifications && groupedNotificationsKeys.length">
    <ng-container *ngFor="let key of groupedNotificationsKeys">
      <div class="notification-panel-title" *ngIf="'' != key">
        {{ key }}
      </div>
      <div class="notification-panel">
        <div
          class="notification"
          *ngFor="let notification of groupedNotifications[key]"
        >
          <ng-container *ngIf="notificationPassesRDFilter(notification)">
            <!-- Toggle yes/no -->
            <div
              class="control"
              *ngIf="notificationTypeToggle == notification.notificationType"
            >
              <div>
                <mat-slide-toggle
                  [checked]="notification.value.activeSelected"
                  (change)="
                    onToggleNotification(
                      notification,
                      this.originalNotificationValues[
                        notification.originalIndex
                      ]
                    )
                  "
                  [(ngModel)]="notification.value.activeSelected"
                  [disabled]="
                    readOnlyContent ||
                    !isUserResponsibleOfNotification(notification)
                  "
                >
                  {{
                    notification.value.activeSelected
                      ? notification.notificationLabelActive
                      : notification.notificationLabelInactive
                  }}
                </mat-slide-toggle>
              </div>
            </div>

            <!-- Comment -->
            <div
              class="control"
              *ngIf="
                notificationTypeComment == notification.notificationType ||
                notificationTypeCommentOff == notification.notificationType
              "
            >
              <div>
                <mat-slide-toggle
                  [checked]="notification.value.activeSelected"
                  (change)="
                    onToggleNotification(
                      notification,
                      this.originalNotificationValues[
                        notification.originalIndex
                      ]
                    )
                  "
                  [(ngModel)]="notification.value.activeSelected"
                  [disabled]="
                    readOnlyContent ||
                    !isUserResponsibleOfNotification(notification)
                  "
                >
                  {{
                    notification.value.activeSelected
                      ? notification.notificationLabelActive
                      : notification.notificationLabelInactive
                  }}
                </mat-slide-toggle>
              </div>
              <div>
                <mat-form-field
                  *ngIf="
                    (notificationTypeComment == notification.notificationType &&
                      notification.value.activeSelected) ||
                    (notificationTypeCommentOff ==
                      notification.notificationType &&
                      !notification.value.activeSelected)
                  "
                >
                  <mat-label>{{ notification.inputPlaceholder }}</mat-label>
                  <div matTooltip="{{ notification.value.value }}">
                    <input
                      matInput
                      type="text"
                      (ngModelChange)="
                        onTextNotificationValueChanges(
                          notification,
                          $event,
                          this.originalNotificationValues[
                            notification.originalIndex
                          ].value || ''
                        )
                      "
                      [(ngModel)]="notification.value.value"
                      [disabled]="
                        readOnlyContent ||
                        !isUserResponsibleOfNotification(notification)
                      "
                    />
                  </div>
                  <mat-hint
                    class="alert"
                    *ngIf="
                      notification.required &&
                      !readOnlyContent &&
                      !notification.value.value &&
                      isUserResponsibleOfNotification(notification)
                    "
                    >Este campo es obligatorio.</mat-hint
                  >
                </mat-form-field>
              </div>
            </div>

            <!-- File attachment -->
            <div
              class="control attachment"
              *ngIf="notificationTypeFile == notification.notificationType"
            >
              <mat-form-field>
                <mat-label>{{ notification.inputPlaceholder }}</mat-label>
                <div matTooltip="{{ notification.value.value }}">
                  <input
                    matInput
                    type="text"
                    (ngModelChange)="
                      onTextNotificationValueChanges(
                        notification,
                        $event,
                        this.originalNotificationValues[
                          notification.originalIndex
                        ].value || ''
                      )
                    "
                    [(ngModel)]="notification.value.value"
                    [disabled]="
                      readOnlyContent ||
                      !isUserResponsibleOfNotification(notification)
                    "
                  />
                </div>
                <mat-hint
                  class="alert"
                  *ngIf="
                    notification.required &&
                    !readOnlyContent &&
                    !notification.value.value
                  "
                  >Este campo es obligatorio.</mat-hint
                >
              </mat-form-field>
              <ng-container
                *ngIf="
                  !notification.value.attachment?.filePath &&
                  !notification.fileToUpload?.name
                "
              >
                <input
                  type="file"
                  class="file-input"
                  accept=".xls, .xlsx, .pdf"
                  (change)="onFileSelected($event, notification)"
                  #fileUpload
                />
                <button
                  mat-button
                  class="attachment-button"
                  title="{{ notification.notificationLabelActive }}"
                  (click)="fileUpload.click()"
                  [disabled]="
                    readOnlyContent ||
                    !isUserResponsibleOfNotification(notification)
                  "
                >
                  <mat-icon class="material-icons-outlined"
                    >file_upload</mat-icon
                  >{{ notification.notificationLabelActive }}
                </button>
              </ng-container>
              <ng-container *ngIf="notification.value.attachment?.filePath">
                <a
                  href="{{dhoApiUrl}}/{{ notification.value.attachment?.filePath }}"
                  download="{{ getNameFile(notification.value.attachment) }}"
                  class="attachment-link"
                  target="_blank"
                >
                  {{ getNameFile(notification.value.attachment) }}
                </a>
              </ng-container>
              <ng-container *ngIf="!notification.value.attachment?.filePath">
                <a
                  href="{{ notification.fileToUpload?.name }}"
                  class="attachment-link"
                  (click)="deniedDownload($event)"
                >
                  {{ notification.fileToUpload?.name }}
                </a>
              </ng-container>
              <button
                mat-button
                class="delete-button"
                (click)="
                  onFileDeleted(notification);
                  onToggleNotification(
                    notification,
                    this.originalNotificationValues[notification.originalIndex]
                  )
                "
                *ngIf="
                  !readOnlyContent &&
                  (notification.value.attachment?.filePath ||
                    notification.fileToUpload?.name) &&
                  isUserResponsibleOfNotification(notification)
                "
              >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
              </button>
            </div>

            <!-- File attachment with toggle button (without text input)-->
            <div
              class="control attachment toggle"
              *ngIf="
                notificationTypeFileWithToggle == notification.notificationType
              "
            >
              <mat-slide-toggle
                [checked]="notification.value.activeSelected"
                (change)="
                  onToggleNotification(
                    notification,
                    this.originalNotificationValues[notification.originalIndex]
                  )
                "
                [(ngModel)]="notification.value.activeSelected"
                [disabled]="
                  readOnlyContent ||
                  !isUserResponsibleOfNotification(notification)
                "
              >
                {{
                  notification.value.activeSelected
                    ? notification.notificationLabelActive
                    : notification.notificationLabelInactive
                }}
              </mat-slide-toggle>
              <ng-container *ngIf="notification.value.activeSelected">
                <div
                  *ngIf="
                    !notification.value.attachment?.filePath &&
                    !notification.fileToUpload?.name
                  "
                  class="uploader"
                >
                  <input
                    type="file"
                    class="file-input"
                    accept=".xls, .xlsx, .pdf, image/*"
                    (change)="onFileSelected($event, notification)"
                    #fileUpload
                  />
                  <button
                    mat-button
                    class="attachment-button"
                    title="{{ notification.inputPlaceholder }}"
                    (click)="fileUpload.click()"
                    [disabled]="readOnlyContent"
                  >
                    <mat-icon class="material-icons-outlined"
                      >file_upload</mat-icon
                    >{{ notification.inputPlaceholder }}</button
                  ><br />
                  <mat-hint
                    class="alert"
                    *ngIf="
                      notification.required &&
                      !readOnlyContent &&
                      isUserResponsibleOfNotification(notification)
                    "
                    >Este campo es obligatorio.</mat-hint
                  >
                </div>
                <div
                  *ngIf="
                    notification.value.attachment?.filePath ||
                    notification.fileToUpload?.name
                  "
                  class="uploaded"
                >
                  <ng-container *ngIf="notification.value.attachment?.filePath">
                    <a
                      href="{{dhoApiUrl}}/{{
                        notification.value.attachment?.filePath
                      }}"
                      download="{{
                        getNameFile(notification.value.attachment)
                      }}"
                      class="attachment-link"
                      target="_blank"
                    >
                      {{ getNameFile(notification.value.attachment) }}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="notification.fileToUpload?.name">
                    <a
                      href="{{ notification.fileToUpload?.name }}"
                      class="attachment-link"
                      (click)="deniedDownload($event)"
                    >
                      {{ notification.fileToUpload?.name }}
                    </a>
                  </ng-container>
                  <button
                    mat-button
                    class="delete-button"
                    (click)="
                      onFileDeleted(notification);
                      onToggleNotification(
                        notification,
                        this.originalNotificationValues[
                          notification.originalIndex
                        ]
                      )
                    "
                    *ngIf="
                      !readOnlyContent &&
                      isUserResponsibleOfNotification(notification)
                    "
                  >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                  </button>
                </div>
              </ng-container>
            </div>

            <!-- Select -->
            <div
              class="control flexed"
              *ngIf="notificationTypeSelect == notification.notificationType"
            >
              <mat-form-field>
                <mat-label>{{
                  notification.notificationLabelActive
                }}</mat-label>
                <mat-select
                  [(ngModel)]="notification.value.value"
                  [disabled]="
                    readOnlyContent ||
                    !isUserResponsibleOfNotification(notification)
                  "
                  (selectionChange)="
                    onSelectNotificationChanges($event, notification)
                  "
                >
                  <mat-option
                    *ngFor="let option of notification.options"
                    [value]="option.optionValue"
                  >
                    {{ option.optionLabel }}
                  </mat-option>
                </mat-select>
                <mat-hint
                  class="alert"
                  *ngIf="
                    notification.required &&
                    !readOnlyContent &&
                    !notification.value.value &&
                    isUserResponsibleOfNotification(notification)
                  "
                  >Este campo es obligatorio.</mat-hint
                >
              </mat-form-field>
              <mat-form-field
                class="other-value"
                *ngIf="
                  true === notification.value.otherTriggered ||
                  (notification.value.value != undefined &&
                    otherOptionValues.includes(notification.value.value))
                "
              >
                <mat-label>Nombre o identificador</mat-label>
                <div matTooltip="{{ notification.value.otherValue }}">
                  <input
                    matInput
                    type="text"
                    (ngModelChange)="
                      onTextNotificationOtherValueChanges(notification, $event)
                    "
                    [(ngModel)]="notification.value.otherValue"
                    [disabled]="
                      readOnlyContent ||
                      !isUserResponsibleOfNotification(notification)
                    "
                  />
                </div>
                <mat-hint
                  class="alert"
                  *ngIf="
                    notification.required &&
                    !readOnlyContent &&
                    !notification.value.otherValue &&
                    isUserResponsibleOfNotification(notification)
                  "
                  >Este campo es obligatorio.</mat-hint
                >
              </mat-form-field>
            </div>

            <!-- Toggle with radio options -->
            <div
              class="control radio"
              *ngIf="notificationTypeRadio == notification.notificationType"
            >
              <div>
                <mat-slide-toggle
                  [checked]="notification.value.activeSelected"
                  (change)="
                    onToggleRadioNotification(
                      notification,
                      this.originalNotificationValues[
                        notification.originalIndex
                      ]
                    )
                  "
                  [(ngModel)]="notification.value.activeSelected"
                  [disabled]="
                    readOnlyContent ||
                    !isUserResponsibleOfNotification(notification)
                  "
                >
                  {{
                    notification.value.activeSelected
                      ? notification.notificationLabelActive
                      : notification.notificationLabelInactive
                  }}
                </mat-slide-toggle>
                <mat-hint
                  class="alert"
                  *ngIf="
                    !readOnlyContent &&
                    !notification.value.activeSelected &&
                    !notification.value.value &&
                    isUserResponsibleOfNotification(notification)
                  "
                >
                  *La selección del detalle del evento es obligatoria
                </mat-hint>
              </div>
              <div>
                <mat-radio-group
                  [required]="notification.required"
                  (change)="
                    onSelectRadioNotificationValue(
                      notification,
                      this.originalNotificationValues[
                        notification.originalIndex
                      ]
                    )
                  "
                  [disabled]="
                    readOnlyContent ||
                    notification.value.activeSelected ||
                    !isUserResponsibleOfNotification(notification)
                  "
                  [(ngModel)]="notification.value.value"
                >
                  <mat-radio-button
                    *ngFor="let option of notification.options"
                    [value]="option.optionValue"
                  >
                    {{ option.optionLabel }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>

            <button
              mat-button
              *ngIf="
                notification.alwaysAlert ||
                notificationTypeRadio == notification.notificationType ||
                notification.value.activeSelected
              "
              [ngClass]="{ alert: true, active: notification.value.alert }"
              (click)="onNotificationAlertChanges(notification)"
              matTooltip="{{
                !notification.value.alert
                  ? 'Activá si crees que este ítem requiere atención especial'
                  : 'Desactivá si crees que este ítem NO requiere atención especial'
              }}"
              [disabled]="
                readOnlyContent ||
                !isUserResponsibleOfNotification(notification)
              "
            >
              <span class="material-icons-outlined"> report_problem </span>
            </button>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div
    class="notification-actions"
    *ngIf="
      (displayNotifications || undefined != notificationWellControlEvent) &&
      !readOnlyContent
    "
  >
    <button mat-button class="save" title="Guardar" (click)="save()">
      <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
    </button>
  </div>
</div>
